import { Box } from '@mui/material';
import { BoxStatus } from '@utils/constants/enums';
import { useTranslation } from 'react-i18next';

const statusUi: Record<BoxStatus, { label: string; color: string }> = {
  UNUSED: { label: 'security_box.unsued', color: '#426AB3' },
  IN_USE: { label: 'security_box.currently_in_the_building', color: '#EA4335' },
  UNUSABLE: { label: 'security_box.not_available', color: '#7F7F7F' },
};

type Props = {
  status?: BoxStatus;
  clickable?: boolean;
  onClick?: () => void;
  width?: number;
  height?: number;
};

const BoxUsageStatus = ({ status, width = 130, height = 50 }: Props) => {
  const { t } = useTranslation();
  if (!status) {
    return null;
  }
  const { label, color } = statusUi[status];

  const commonSx = {
    height: height,
    width: width,
    px: 3,
    borderRadius: '25px',
    color: '#fff',
    backgroundColor: color,
    fontSize: 16,
    letterSpacing: '0.5px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
  } as const;

  return (
    <Box
      sx={{
        ...commonSx,
        cursor: 'default',
      }}
    >
      {t(label)}
    </Box>
  );
};

export default BoxUsageStatus;
